import { createComparingLifecycle } from "./lifecycle";
export function onWillReceiveProps(callback) {
    return createComparingLifecycle("componentWillReceivePropsCallback", callback);
}
export default onWillReceiveProps;

//# sourceMappingURL=onWillReceiveProps.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reassemble/lib/onWillReceiveProps.js
// module id = 213
// module chunks = 0